import(/* webpackMode: "eager" */ "/vercel/path0/src/app/world/page.tsx");
